import React, { Component } from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import { withApollo } from 'react-apollo';

const MY_CONTACTS = gql`
  query MyContacts {
    myContacts {
      _id
      name
      image {
        small
      }
      isOnline
    }
  }
`;

export default Comp => {
  /* eslint-disable react/prefer-stateless-function */
  @withApollo
  class WithMyContactsQuery extends Component {
    static propTypes = {
      client: PropTypes.object.isRequired,
      forwardedRef: PropTypes.object,
    };

    static defaultProps = {
      forwardedRef: null,
    };

    handleGetMyContacts = async () => {
      const { client: apolloClient } = this.props;

      const { data } = await apolloClient.query({
        query: MY_CONTACTS,
      });

      return data.myContacts;
    };

    render() {
      const { forwardedRef, ...props } = this.props;
      return <Comp {...props} ref={forwardedRef} onGetMyContacts={this.handleGetMyContacts} />;
    }
  }

  return React.forwardRef((props, ref) => <WithMyContactsQuery {...props} forwardedRef={ref} />);
};
